/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import camUpload from '../../../../assets/images/cam-upload.png';
import noverif from '../../../../assets/images/no-verif.svg';
import verif from '../../../../assets/images/verif.svg';
import Button from '../../../../assets/styles/Button';
import Text from '../../../../assets/styles/Text';
import CustomMidia from '../../../../components/CustomMidia';
import Loader from '../../../../components/Loader';
import Title from '../../../../components/Title';
import MediaUploadsService from '../../../../services/MediaUploadsService';
import { useStore } from '../../../../stores';
import diffInDays from '../../../../utils/diffInDays';
import formatFullDate from '../../../../utils/formatFullDate';
import preloadMedia from '../../../../utils/preloadMedia';
import preloadVerification from '../../../../utils/preloadVerification';
import * as styles from './styles';

export default function Uploads({ show }) {
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [uploads, setUploads] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [verification, setVerification] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    hasMore: false,
    total: 0,
  });

  const user = useStore((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    async function loadVerificationMedia() {
      try {
        const { urls } = await MediaUploadsService.listVerification(user.id);

        setVerification(urls);

        const bannerUrl = urls?.bannerPhoto || urls?.profilePhoto;
        const profileUrl = urls?.profilePhoto;

        await preloadVerification([bannerUrl, profileUrl]);
      } catch (error) {
        console.error('Erro ao carregar mídia de verificação:', error);
      }
    }

    async function loadUploadMedia(resetList = true) {
      try {
        if (resetList) {
          setLoading(true);
          setUploads([]);
          setPagination((prev) => ({ ...prev, page: 1 }));
        }

        const page = resetList ? 1 : pagination.page;
        const result = await MediaUploadsService.listMedias(
          user.id,
          selectedType,
          page
        );

        if (resetList) {
          setUploads(result.urls || []);
        } else {
          setUploads((prev) => [...prev, ...(result.urls || [])]);
        }

        setPagination({
          page: result.pagination?.page || 1,
          hasMore: result.pagination?.hasMore || false,
          total: result.pagination?.total || 0,
        });

        // Preload apenas das novas mídias
        if (result.urls && result.urls.length > 0) {
          await preloadMedia(result.urls);
        }
      } catch (error) {
        console.error('Erro ao carregar mídias:', error);
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    }

    loadVerificationMedia();
    loadUploadMedia(true);
  }, [user.id, selectedType]);

  function handleSelected(type) {
    setSelectedType((prev) => (prev === type ? null : type));
  }

  async function loadMoreMedia() {
    if (loadingMore || !pagination.hasMore) return;

    try {
      setLoadingMore(true);

      const result = await MediaUploadsService.listMedias(
        user.id,
        selectedType,
        pagination.page + 1
      );

      setUploads((prev) => [...prev, ...(result.urls || [])]);
      setPagination({
        page: result.pagination?.page || pagination.page,
        hasMore: result.pagination?.hasMore || false,
        total: result.pagination?.total || 0,
      });

      // Preload das novas mídias
      if (result.urls && result.urls.length > 0) {
        await preloadMedia(result.urls);
      }
    } catch (error) {
      console.error('Erro ao carregar mais mídias:', error);
    } finally {
      setLoadingMore(false);
    }
  }

  console.log({ verification });

  const diffDays = diffInDays(verification.updateMedia, Date.now());

  if (loading)
    return (
      <styles.Container $show={show}>
        <Loader isLoading={loading} minimal size={60} />
      </styles.Container>
    );

  return (
    <styles.Container $show={show}>
      <styles.Row>
        <styles.Collumn $max={400}>
          <styles.InfoVerif $diff={diffDays > 180}>
            <div>
              <Text.P>
                {diffDays > 180
                  ? 'Sua mídia de comparação está desatualizada'
                  : 'Sua mídia de comparação está atualizada'}
              </Text.P>
            </div>
            <div>
              <Text.Span>Último envio:</Text.Span>
              <Text.Span>{formatFullDate(verification.updateMedia)}</Text.Span>
            </div>
          </styles.InfoVerif>

          <styles.WrapImg>
            <img
              src={verification?.bannerPhoto || verification?.profilePhoto}
              alt="banner"
              className="banner"
            />
            <img
              src={verification?.profilePhoto}
              alt="profile"
              className="profile"
            />

            <Button
              $padding={8}
              $radius={32}
              className="link"
              onClick={() => navigate('/modeluploads')}
            >
              <Text.P>Alterar Foto de Perfil / Banner</Text.P>
            </Button>
          </styles.WrapImg>

          <Link to="/modelmidias">
            <img src={camUpload} alt="uploads" />
          </Link>
        </styles.Collumn>

        <styles.Collumn $max={460}>
          <styles.GroupCam>
            <styles.TopCam>
              <Text.P>SUA MÍDIA DE COMPARAÇÃO</Text.P>
              {diffDays > 180 ? (
                <img src={noverif} alt="verif" className="no" />
              ) : (
                <img src={verif} alt="verif" className="yes" />
              )}
            </styles.TopCam>

            <CustomMidia
              key={verification?.id}
              midia={{
                url: verification?.verificationMedia,
                mediaType: 'video',
              }}
              icon={false}
              index={999}
            />

            <Button
              $padding={10}
              $radius={32}
              className="link"
              onClick={() => navigate('/modeluploads')}
            >
              <Text.P>Alterar Mídia</Text.P>
            </Button>
          </styles.GroupCam>
        </styles.Collumn>
      </styles.Row>

      <styles.Collumn $gap>
        <Title title="GALERIA DE MÍDIAS" small />

        {uploads.length <= 0 && !loading && (
          <Text.P $bold className="empty">
            Não possui mídias
          </Text.P>
        )}

        {uploads.length > 0 && (
          <>
            <styles.GroupButton $selected={selectedType}>
              <button type="button" onClick={() => handleSelected('photo')}>
                <Text.Span $bold>Fotos</Text.Span>
              </button>
              <button type="button" onClick={() => handleSelected('video')}>
                <Text.Span $bold>Vídeos</Text.Span>
              </button>
            </styles.GroupButton>

            <styles.GroupUpload>
              {uploads?.map((upload, index) => (
                <CustomMidia
                  key={upload.id}
                  midia={{ url: upload.url, mediaType: upload.mediaType }}
                  index={index}
                  isImg={upload.mediaType === 'photo'}
                  total={uploads.length}
                />
              ))}
            </styles.GroupUpload>

            {pagination.hasMore && (
              <styles.LoadMoreContainer>
                <styles.LoadMoreButton
                  type="button"
                  onClick={loadMoreMedia}
                  disabled={loadingMore}
                >
                  {loadingMore ? (
                    <>
                      <Loader isLoading={loadingMore} minimal size={20} />
                      <Text.Span>Carregando...</Text.Span>
                    </>
                  ) : (
                    <Text.Span $bold>Ver mais</Text.Span>
                  )}
                </styles.LoadMoreButton>
              </styles.LoadMoreContainer>
            )}
          </>
        )}
      </styles.Collumn>
    </styles.Container>
  );
}

Uploads.propTypes = {
  show: PropTypes.bool.isRequired,
};
